import { PropsWithChildren } from 'react';
import { ThemeProvider } from '@mui/material';
import { colorThemes, getTheme } from 'shared/config';

export const withTheme: React.FC<PropsWithChildren> = ({ children }) => (
  <ThemeProvider theme={getTheme(colorThemes)}>{children}</ThemeProvider>
);
